import { ITripPlannerValues, SelectItem } from '../types/locationTypes'
import { v4 as uuidv4 } from 'uuid';

const createNewPlanner = (id?: undefined | null | string): ITripPlannerValues => ({

    tripPlannerId: id === undefined ? uuidv4() : id,

    noOfStretchers: null,

    noOfPatientSeats: null,

    maxPatientAcuity: null,

    noOfPickupDropoffs: null,

    isMutliloadAllowed: null,

    schedulingLeadTtime: null,
    
    pricing:null,

    deleted: null,

    sequence: null,

    plannerName:null,

    sharedPlannerId:null,

    sharingRole:null,

    sharedlocation:null,

    sharing:null,

    plannerNameStatus:null,

    plannerNamePlaceholder :null,

    tempSave:null,

    breakStartMon:null,

    breakDurationMon: null,

    maxBreakDelayMon: null,

    breakStartTue: null,

    breakDurationTue: null,

    maxBreakDelayTue: null,

    breakStartWed: null,

    breakDurationWed: null,

    maxBreakDelayWed: null,

    breakStartThu: null,

    breakDurationThu: null,

    maxBreakDelayThu: null,

    breakStartFri: null,

    breakDurationFri: null,

    maxBreakDelayFri: null,

    breakStartSat: null,

    breakDurationSat: null,

    maxBreakDelaySat: null,

    breakStartSun: null,

    breakDurationSun: null,

    maxBreakDelaySun: null,

    sunFrom: null,

    monFrom: null,

    tueFrom: null,

    wedFrom: null,

    thurFrom: null,

    friFrom: null,

    satFrom: null,

    sunTo: null,

    monTo: null,

    tueTo: null,

    wedTo: null,

    thurTo: null,

    friTo: null,

    satTo: null,

    servicedBy:null,
    
    breakStartMonString: null,

    breakDurationMonString: null,

    maxBreakDelayMonString: null,

    breakStartTueString: null,

    breakDurationTueString: null,

    maxBreakDelayTueString: null,

    breakStartWedString: null,

    breakDurationWedString: null,

    maxBreakDelayWedString: null,

    breakStartThuString: null,

    breakDurationThuString: null,

    maxBreakDelayThuString: null,

    breakStartFriString: null,

    breakDurationFriString: null,

    maxBreakDelayFriString: null,

    breakStartSatString: null,

    breakDurationSatString: null,

    maxBreakDelaySatString: null,

    breakStartSunString: null,

    breakDurationSunString: null,

    maxBreakDelaySunString: null,

    monFromString: null,

    tueFromString: null,

    wedFromString: null,

    sunFromString: null,

    thurFromString: null,

    friFromString: null,

    satFromString: null,

    sunToString: null,

    monToString: null,

    tueToString: null,

    wedToString: null,

    thurToString: null,

    friToString: null,

    satToString: null,
});

const convertTripPlannerForRequest = (name: string, value: any): any => {
    if (name === 'noOfPatientSeats' ||
        name === 'noOfPickupDropoffs' ||
        name === 'noOfStretchers' ||
        name === 'schedulingLeadTtime') {
        return value ? Number(value) : null;
    } else  {
        return value;
    }
}

const converTripPlannerFromResponse = (name: string, value: any): any => {
    if (name === 'noOfPatientSeats' ||
        name === 'noOfPickupDropoffs' ||
        name === 'noOfStretchers' ||
        name === 'schedulingLeadTtime'||
        name === 'plannerName') {
        return value ? value.toString() : null;
    } else {
        return value;
    }
}

const prepareTripPlannerFromResponse = (tripPlannerModel: any) => {
    let existingPlanner = createNewPlanner(tripPlannerModel.tripPlannerId as string);
    for (const k in existingPlanner) {
        if (tripPlannerModel.hasOwnProperty(k)) {
            const key = k as keyof ITripPlannerValues;
            (existingPlanner[key] as any) = converTripPlannerFromResponse(k, tripPlannerModel[k]);
        }
    }
    return existingPlanner;
}

const prepareTripPlannerForRequest = (planner: any) => {
    let tripPlannerModel = Object.assign(
        {}, ...Object.keys(planner).map(key => {
            
            return { [key]: convertTripPlannerForRequest(key, planner[key]) }
        }
        )
    );
    return tripPlannerModel;
}


export {
    createNewPlanner,
    prepareTripPlannerFromResponse,
    prepareTripPlannerForRequest
}